window.get_modal_markup = ->
  if ($("#modal").length > 0)
    try
      $('#modal').modal('hide')
    catch e
    $('#modal').remove()
  return $('<div id="modal" class="modal"></div>').appendTo('body')

window.get_modal_content = (title, content, footer)->
  return """
    <div class="modal-dialog">
      <div class="modal-content">
        <div class="modal-header">
          <button type="button" class="close" data-dismiss="modal" aria-hidden="true">×</button>
          <h4 class="modal-title">#{title}</h4>
        </div>
        <div class="modal-body">#{content}</div>
        <div class="modal-footer">#{footer}</div>
      </div>
    </div>
         """

apply_callback = (modal, name)->
  info = modal.data(name)
  return unless info?
  modal.data(name, null)
  $.ajax
    url: info.url
    type: info.method

$(->
  $('.modal.immediate').modal()

  $(document).on 'click', 'a.open-modal', (e)->
    e.preventDefault()
    the_link = $(this)
    return false if the_link.data('busy')
    the_link.data('busy', true)
    the_modal = $('#' + the_link.data('target'))
    to_load = the_modal
    if the_modal.length < 1
      the_modal = window.get_modal_markup()
      if the_link.hasClass('with-frame')
        the_modal.html(window.get_modal_content(the_link.data('title'), '', ''))
        to_load = the_modal.find('.modal-body')
      else
        to_load = the_modal
    if $(this).data('modal-method') == 'post'
      payload = {}
    else
      payload = null

    to_load.load the_link.attr('href'), payload, ->
      if window.cp_cancel_modal
        window.cp_cancel_modal = false
      else
        if the_link.data('accepts')?
          the_modal.data('accepts', the_link.data('accepts'))
        if the_link.data('title')?
          the_modal.find('.modal-title').html(the_link.data('title'))
        if the_link.data('class')?
          the_modal.attr('class', 'modal ' + the_link.data('class'))
        else
          the_modal.attr('class', 'modal')
        the_modal.modal()
      the_link.data('busy', false)
    false

  $(document).on 'click', '.modal .modal-footer .submit-form', ->
    $('.modal textarea.tinymce').each ->
      ted = tinymce.get($(this).attr('id'))
      if ted? && ted.getDoc()?
        ted.save()
    the_button = $(this)
    the_modal = the_button.closest('.modal')
    the_modal.data('cancel_callback', null)
    if the_button.hasClass('external')
      f = the_button.closest('form')
    else
      f = the_modal.find('form')
    if f.data('remote')?
      the_button.prop('disabled', true)
      if the_modal.data('accepts') == 'js'
        f.attr 'action', f.attr('action') + '.js'
      f.on 'ajax:complete', ->
        the_button.prop('disabled', false)
      f.on 'ajax:success', ->
        apply_callback(the_modal, 'success_callback')
        the_modal.modal('hide')
        $('.modal-backdrop').remove() # this should not be necessary
      nonBlankFileInputs = $.rails.nonBlankInputs f, $.rails.fileInputSelector
      if nonBlankFileInputs
        $.rails.fire f, 'ajax:aborted:file', [nonBlankFileInputs]
      else
        ajax_opts =
          url: f.attr('action')
          data: f.serialize()
          success: (data)->
            f.trigger 'ajax:success'
        if f.attr('method')?
          ajax_opts.type = f.attr('method')
        else
          ajax_opts.type = 'POST'
        $.ajax ajax_opts
    else
      apply_callback(the_modal, 'success_callback')
      f.submit()
    false

  $(document).on('show.bs.modal', '.modal.variable-title', (e)->
    if e.relatedTarget?
      $(this).find('.modal-title').html($(e.relatedTarget).data('title'))
  )

  $(document).on('show.bs.modal', '.modal.reset', ->
    $(this).find('form').each ->
      this.reset()
  )

  editor_utils = require('./editor_utils.coffee')
  $(document).on 'show.bs.modal', '.modal', ->
    $(this).find('.modal-footer .submit-form').prop('disabled', false)
    the_modal = $(this)
    editor_utils.tinymce_enable($(this).find('textarea.tinymce'), the_modal, true)

  $(document).on 'hide.bs.modal', '.modal', ->
    the_modal = $(this)
    editor_utils.tinymce_disable($(this).find('textarea.tinymce'), the_modal)

  $('.confirm-dialog').change ->
    the_input = $(this)
    if the_input.val() != the_input.data('confirm-value')
      $('#' + $(this).data('modal')).modal().find('.revert').click ->
        the_input.val(the_input.data('confirm-value'))

  $(document).on 'hide.bs.modal', '.modal', ->
    $(this).data('success_callback', null)
    apply_callback($(this), 'cancel_callback')

  $(document).on 'click', 'a.open-collapse', ->
    the_link = $(this)
    the_collapse = $('#' + the_link.data('target'))
    if the_collapse.hasClass('in')
      the_collapse.collapse('hide').on 'hidden.bs.collapse', ->
        $('body').removeClass('loading')
    else
      content = the_collapse.find('.content')
      if content.length > 0
        content.load the_link.attr('href'), ->
          the_collapse.collapse('show')
      else
        the_collapse.load the_link.attr('href'), ->
          the_collapse.collapse('show')
    false

  # work-around modal sizing/scrolling issue with multiple modals
  $(document).on 'hidden.bs.modal', '.modal', ->
    activeModal = $('.modal.in:last', 'body').data 'bs.modal'
    if activeModal
      activeModal.$body.addClass 'modal-open'
      activeModal.enforceFocus()
      activeModal.handleUpdate()
)
